<template>
  <div class="home">
    <div class="head-one">
						<h2>推荐商品</h2>
					</div>
    <el-row :gutter="20">
      <el-col v-for="(o, index) in homeImgList" :key="o.key" :span="6">
        <el-card :body-style="{ padding: '0px' }">
          <el-image
            style="width: 100px; height: 100px"
            :src="require('@/assets/' + o.key + '/' + o.key + '.jpg')"
            :zoom-rate="1.2"
            :initial-index="4"
            :preview-src-list="[
              require('@/assets/' + o.key + '/' + o.key + '.jpg'),
              require('@/assets/' + o.key + '/' + o.key + '_1.jpg'),
              require('@/assets/' + o.key + '/' + o.key + '_2.jpg'),
              require('@/assets/' + o.key + '/' + o.key + '_3.jpg'),
              require('@/assets/' + o.key + '/' + o.key + '_4.jpg'),
            ]"
            fit="cover"
          />
          <div style="padding: 14px">
            <span>{{ o.label }}</span>
            <div class="bottom">
              <span class="introduce">{{ o.introduce }}</span>
            <el-button v-if="o.taobao" type="primary" plain class="button" ><a :href="o.taobao" target="_blank">立即购买</a></el-button>
          </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="background-color:#F3F3F3;">
      <div v-if="company" class="head-one">
        <h3>公司简介</h3>
        <span>
        </span>
        <p>
          {{company}}

        </p>
      </div>
      <div v-if="shop" class="head-one">
        <h3><a href="https://shop471316383.taobao.com/">旺铺</a>介绍</h3>
        <span>
        </span>
        <p>

          {{shop}}
        </p>
      </div>
      <div v-if="welcome" class="head-one">
        <h3><a href="https://shop471316383.taobao.com/">欢迎合作</a></h3>
        <span>
        </span>
        <p>

          {{welcome}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      homeImgList: homeImgList,
      company:company,
      shop:shop,
      welcome:welcome,
    };
  },
  components: {},
  created() {},
  methods: {
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.introduce {
  font-size: x-small;
  display: inline-block;
  color: rgb(102, 101, 100);
  width: 75%;
}
.el-col {
  margin-bottom: 20px;
}
.bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 4px;
    float: right;
  }
  .head-one span {
    height: 3px;
    background: #303030;
    display: inline-block;
    width: 20%;
    margin: 0;
    padding: 0;
}
</style>